import { SpacerProps } from './component';
export interface SpacerHtmlRendererExtraProps {}

export type SpacerHtmlRendererProps = SpacerProps &
  SpacerHtmlRendererExtraProps;
